// polyfills for ie11
import 'core-js/stable';
import 'date-input-polyfill';

import React from 'react';
import { render, unmountComponentAtNode as remove } from 'react-dom';

import Promise from 'promise-polyfill';
import 'whatwg-fetch';

import Playbill from '~/pages/Playbill';
import NewsFront from '~/pages/NewsFront';
import Umakhi from '~/components/editor';
import CoursePlaybill from '~/popups/CoursePlaybill';
import CuratorMessage from '~/components/popups/CuratorMessage';

import Auth from '~c/popups/Auth';
import Subscribe from '~c/popups/Subscribe';
import { SiteReg } from '~p/EventReg/SiteReg'; 
import RegistrationSetPasswordPage from '~p/RegistrationSetPasswordPage';
import { EventReg } from '~p/EventReg'; 
import ProfilePage from '~p/ProfilePage';
import Contacts from '~c/Contacts';
import BlockCTA from '~/components/editor/BlockCTA';
import BlockCTAFreeEvents from '~c/editor/BlockCTAFreeEvents/BlockCTAFreeEvents';
import CourseList from '~/popups/CourseList';
import NearestEvent from '~c/NearestEvent';
import CookieBanner from '~c/CookieBanner';
import ToTopButton from '~c/ToTopButton';
import { ErrorBoundary } from './components/popups/ErrorSender';


// Metrika
import metrikaGoal from '~/helpers/metrikaGoal';

window.dataLayer = window.dataLayer || [];

const components = [
  {
    component: <CuratorMessage />,
    target: document.getElementById('curator-message'),
  },
  {
    component: <Playbill />,
    target: document.getElementById('playbill'),
  },
  {
    component: <Umakhi page={$('#page-editor').data('page') || null} />,
    target: document.getElementById('page-editor'),
  },
  {
    component: <ErrorBoundary><SiteReg 
      className="registration-container" 
      allowChangeType 
      onComplete={() => window.location.assign('/profile/')} 
      onAuth={() => window.location.assign('/profile/')}
    /></ErrorBoundary>,
    target: document.getElementById('page-registration'),
  },
  {
    component: <ErrorBoundary><RegistrationSetPasswordPage /></ErrorBoundary>,
    target: document.getElementById('page-registration_set_password'),
  },
  {
    component: (
      <ErrorBoundary>
      <EventReg
        eventCode={
          document.getElementById('page-registration_course')?.dataset
            .event_codes || ''
        }
        eventType={
          document.getElementById('page-registration_course')?.dataset
            .event_type || ''
        }
        pageCode={
          document.getElementById('page-registration_course')?.dataset
            .page_code || ''
        }
      />
      </ErrorBoundary>
    ),
    target: document.getElementById('page-registration_course'),
  },
  {
    component: <ErrorBoundary><ProfilePage /></ErrorBoundary>,
    target: document.getElementById('page-profile'),
  },
  {
    component: <NewsFront />,
    target: document.getElementById('news-front'),
  },
  {
    component: <Contacts page={$('#aside-contacts').data('page') || null} />,
    target: document.getElementById('aside-contacts'),
  },
  {
    component: <NearestEvent />,
    target: document.querySelectorAll('.event-checkin-react'),
  },
  {
    component: <CookieBanner />,
    target: document.getElementById('cookie-banner'),
  },
  {
    component: <ToTopButton />,
    target: document.getElementById('toTopButton'),
  },
];

$(() => {
  components.forEach(item => {
    if (!item.target) return;

    if (item.target instanceof NodeList) {
      item.target.forEach(target => render(item.component, target));
    } else {
      render(item.component, item.target);
    }
  });
});

// CTA blocks
$('.cta__wrapper').each(function() {
  const disciplines = $(this)
    .data('disciplines')
    .replace(/[\["\]]/g, '')
    .split(',');
  const pageCode =
    $('#umakhi').data('page_code') || $('#page-editor').data('page_code');
  const duration = $(this).data('duration');
  const btnText = $(this).data('btn-text');
  render(
    <BlockCTA
      disciplines={disciplines}
      pageCode={pageCode}
      duration={duration}
      btnText={btnText}
    />,
    $(this)[0],
  );
});

// eslint-disable-next-line func-names
$('.cta-free__wrapper').each(function() {
  const disciplines = $(this)
    .data('disciplines')
    .replace(/[\["\]]/g, '')
    .split(',');
  const pageCode =
    $('#umakhi').data('page_code') || $('#page-editor').data('page_code');
  const image = $(this).data('image');
  const title = $(this).data('title');
  render(
    <BlockCTAFreeEvents
      disciplines={disciplines || ''}
      image={image}
      title={title}
      pageCode={pageCode}
    />,
    $(this)[0],
  );
});

// Simple popups and rerender react popups after open
function openPopupWithContent(contentHref) {
  const content = $(contentHref);
  if (!content.length) {
    return;
  }

  $.magnificPopup.open({
    items: {
      src:
        `<div class="umakhi"><div class="block"><div class="simple-popup">${ 
        content.html() 
        }</div></div></div>`,
    },
    closeOnBgClick: true,
    type: 'inline',
    callbacks: {
      open() {
        $('.umakhi .block .simple-popup .cta__wrapper').each(function() {
          const disciplines = $(this)
            .data('disciplines')
            .replace(/[\["\]]/g, '')
            .split(',');
          const pageCode =
            $('#umakhi').data('page_code') ||
            $('#page-editor').data('page_code');
          const duration = $(this).data('duration');
          const btnText = $(this).data('btn-text');
          render(
            <BlockCTA
              disciplines={disciplines}
              pageCode={pageCode}
              duration={duration}
              btnText={btnText}
            />,
            $(this)[0],
          );
        });
      },
      close() {
        cleanUrl();
      },
    },
  });
}

const openPopupWithContentFromURL = () => {
  const contentHrefs = window.location.href.split('#');
  const contentHref = contentHrefs.pop();
  if (contentHref.includes('popup')) {
    openPopupWithContent(`#${contentHref}`);
  }
};

$("a[href^='#popup']").click(function() {
  openPopupWithContent($(this).attr('href'));
});

// Popups
// Course playbill
$(document).on('click', 'a[href="#course-reg"]', function(e) {
  e.preventDefault();
  const code = $(this).attr('data-code');
  const pageCode =
    $('#umakhi').data('page_code') || $('#page-editor').data('page_code');

  $.magnificPopup.open({
    items: {
      src: '#popup',
      type: 'inline',
    },

    closeOnBgClick: false,
    removalDelay: 250,
    mainClass: 'mfp-anim',
    callbacks: {
      beforeOpen() {
        this.st.mainClass = 'mfp-anim popup-info';
      },
      open() {
        document.body.style.overflow = 'hidden';
        render(
          <CoursePlaybill
            code={code
              .replace(/[\["\]]/g, '')
              .split(',')
              .join('/')}
            pageCode={pageCode}
          />,
          $('#popup')[0],
        );
      },
      close() {
        document.body.style.overflow = '';
        render(<div />, $('#popup')[0]);
      },
    },
  });
});

// Feedback on contacts page
$("a[href='mailto:academy.registration@email.tedo.ru?subject=Академия ТеДо: вопрос с сайта']").click(function(e) {
  // e.preventDefault();
  // const manager = $(this).data('manager');
  // $.magnificPopup.open({
  //   items: {
  //     src: '#popup',
  //   },
  //   removalDelay: 250,
  //   closeOnBgClick: false,
  //   callbacks: {
  //     beforeOpen() {
  //       this.st.mainClass = 'mfp-anim';
  //     },
  //     open() {
  //       render(<CuratorMessage manager={manager} />, $('#popup')[0]);
  //     },
  //     close() {
  //       remove($('#popup')[0]);
  //     },
  //   },
  // });
});

function getUrlParameters (contentHref) {
  const urlParameters = contentHref.split('?').pop();
  switch (true) {
  case urlParameters.includes('page'):
    return urlParameters;
  default:
    return '';
  }
}

function openAuthPopup(contentHref) {

  const isAuthed = $(this).attr('data-auth') == 'true';

  // if not authed popup auth / register form
  if (!isAuthed) {
    $.magnificPopup.open({
      removalDelay: 250,
      mainClass: 'mfp-anim',
      closeOnBgClick: false,
      items: {
        src: $('#popup'),
        type: 'inline',
      },
      callbacks: {
        open() {
          render(<Auth redirectParameters={getUrlParameters(contentHref)}/>, $('#popup')[0]);
        },
        close() {
          render(<div />, $('#popup')[0]);
        },
      },
    });
  }
}

$(document).on('click', 'a[href="#auth"]', function(e) {
  e.preventDefault();
  openAuthPopup('');
});

function openSubscribePopup() {
  $.magnificPopup.open({
    removalDelay: 250,
    mainClass: 'mfp-anim',
    closeOnBgClick: false,
    items: {
      src: $('#popup'),
      type: 'inline',
    },
    callbacks: {
      open() {
        render(<Subscribe />, $('#popup')[0]);
      },
      close() {
        cleanUrl();
        render(<div />, $('#popup')[0]);
      },
    },
  });
}

function callSubscribePopup(elem) {
  $(document).on('click', elem, function(e) {
    const isAuthed = $(this).attr('data-auth') == 'true';
    if (!isAuthed) {
      openSubscribePopup();
    }
  });
}

callSubscribePopup('a[href="#subscribeGetResponse"]');
callSubscribePopup('.bx-subscribe');

// Dev-mode badge show (left top corner)
if (process.env.NODE_ENV === 'development') {
  $('body').append('<div class="dev-badge">dev</div>');
}

function cleanUrl() {
  const contentHrefs = window.location.href.split('#');
  contentHrefs.pop();
  window.history.pushState('', '', contentHrefs);
}

const openPopupOnLoad = () => {
  const contentHrefs = window.location.href.split('#');
  const contentHref = contentHrefs.pop();
  switch (true) {
    case contentHref.includes('popup'): {
      openPopupWithContent(`#${contentHref}`);
      break;
    }
    case contentHref.includes('subscribeGetResponse'): {
      openSubscribePopup();
      break;
    }
    case contentHref.includes('auth'): {
      if (!window.user.CONTACT_ID) {
        openAuthPopup(contentHref);
      } else {
        window.location.replace(`/profile?${getUrlParameters(contentHref)}`);
      }
      break;
    }
    default:
      
  }
};

$(window).on('load', function() {
  // openPopupWithContentFromURL();
  openPopupOnLoad();
});

// Main navigation popup

$(document).on('click', "a[href^='#tags-']", function(e) {
  e.preventDefault();
  const filters = $(this).attr('href');
  $.magnificPopup.open({
    items: {
      src: '#popup',
    },
    removalDelay: 250,
    closeOnBgClick: false,
    callbacks: {
      beforeOpen() {
        this.st.mainClass = 'mfp-anim';
      },
      open() {
        render(
          <CourseList filters={filters.replace('#tags-', '')} />,
          $('#popup')[0],
        );
      },
      close() {
        render(<div />, $('#popup')[0]);
      },
    },
  });
});
$(document).on('click', '.bx-show-tag', function(e) {
  e.preventDefault();
  const tag = $(this).attr('data-id');
  $.magnificPopup.open({
    items: {
      src: '#popup',
    },
    closeOnBgClick: false,
    removalDelay: 250,
    callbacks: {
      beforeOpen() {
        this.st.mainClass = 'mfp-anim';
      },
      open() {
        render(<CourseList filters={tag.toString()} />, $('#popup')[0]);
      },
      close() {
        render(<div />, $('#popup')[0]);
      },
    },
  });
});

$(document).on('click', 'a[href="#course-list"]', function(e) {
  $.magnificPopup.open({
    items: {
      src: '#popup',
    },
    closeOnBgClick: false,
    removalDelay: 250,
    callbacks: {
      beforeOpen() {
        this.st.mainClass = 'mfp-anim';
      },
      open() {
        render(<CourseList />, $('#popup')[0]);
      },
      close() {
        render(<div />, $('#popup')[0]);
      },
    },
  });
});

$("a[href='/schedule/']").click(function() {
  if (
    window.location.pathname == '/' &&
    process.env.NODE_ENV != 'development'
  ) {
    metrikaGoal('scenario-playbill-open');
  }
});

// Townpicker from bitrix
$(document).ready(function() {
  $(document).click(function(e) {
    if (
      $('.header__town').hasClass('is-open') &&
      !$(e.target).closest('.town__drop').length &&
      !$(e.target).closest('.header__town').length
    ) {
      $('.header__town').removeClass('is-open');
    }
  });

  $('.town.header__town').one('click', 'a[href="#select-city"]', function(
    event,
  ) {
    event.preventDefault();
    const cityCode = $(this).data('code');
      const cityAjax = '/api/v1/geo/city/change/';
    if ($(this).data('code') !== null) {
      fetch(cityAjax + cityCode, { method: 'POST' })
        .then(response => response.json())
        .then(data =>
          data.status == 'success' ? document.location.reload(true) : '',
        );
    }
  });
});

/* HEADER ISPRING BADGE */
const isISpringPopupHidden = localStorage.getItem('isISpringPopupHidden');
const isAuthed = window.user?.LOGIN !== '';
const iSpringCourses = window.user?.ISPRING_REGISTRATION_FORMS || [];
if (!isISpringPopupHidden && isAuthed && iSpringCourses?.length) $('.header-auth__img').addClass('ispring-header-badge');
